import React from 'react'
import UserProfileComponent from '../components/UserProfile'

function UserProfile({ openReviewModal }) {
  return (
    <div>
      <UserProfileComponent openReviewModal={openReviewModal} />
    </div>
  )
}

export default UserProfile